<div class="tabs tabBlue">
 <ng-container *ngIf="isTranslationFeedEnabled">
  <span  class="tablinks all_stories " (click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedHT'"
  [class]="activeFeed === 'translationFeedHT' ? 'active' : ' '" id="tranFeed">HT Translation Feeds</span>
  <span  class="tablinks all_stories " (click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedLM'"
  [class]="activeFeed === 'translationFeedLM' ? 'active' : ' '" id="tranFeed">LM Translation Feeds</span>
 </ng-container>
 <ng-container *ngIf="isEnglishTranslationFeedEnabled">
  <span  class="tablinks all_stories " *ngIf="domainsEnabled.includes('Bangla')"(click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedBangla'"
  [class]="activeFeed === 'translationFeedBangla' ? 'active' : ' '" id="tranFeed">Bangla Translation Feeds</span>
  <span  class="tablinks all_stories " *ngIf="domainsEnabled.includes('Tamil')" (click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedTamil'"
  [class]="activeFeed === 'translationFeedTamil' ? 'active' : ' '" id="tranFeed">Tamil Translation Feeds</span>
  <span  class="tablinks all_stories " *ngIf="domainsEnabled.includes('Telegu')" (click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedTelegu'"
  [class]="activeFeed === 'translationFeedTelegu' ? 'active' : ' '" id="tranFeed">Telegu Translation Feeds</span>
  <span  class="tablinks all_stories " *ngIf="domainsEnabled.includes('Marathi')" (click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedMarathi'"
  [class]="activeFeed === 'translationFeedMarathi' ? 'active' : ' '" id="tranFeed">Marathi Translation Feeds</span>
  <span  class="tablinks all_stories " *ngIf="domainsEnabled.includes('Kannada')" (click)="snowplowAnalytics('Translation Feed');activeFeed = 'translationFeedKannada'"
  [class]="activeFeed === 'translationFeedKannada' ? 'active' : ' '" id="tranFeed">Kannada Translation Feeds</span>
 </ng-container>

</div>
<ng-container [ngSwitch]="activeFeed">
  <ng-container *ngSwitchCase="'translationFeedHT'">
    <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="photogalleryFeedHT" style="display: block;">
      <app-all-wire-feed-listing pageId="translationFeedHT"></app-all-wire-feed-listing>
  </div>
  </ng-container>
  <ng-container *ngSwitchCase="'translationFeedLM'">
      <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="photogalleryFeedLM" style="display: block;">
        <app-all-wire-feed-listing pageId="translationFeedLM"></app-all-wire-feed-listing>
      </div>
  </ng-container>
  <ng-container *ngSwitchCase="'translationFeedBangla'">
    <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="translationFeedBangla" style="display: block;">
      <app-all-wire-feed-listing pageId="translationFeedBangla"></app-all-wire-feed-listing>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'translationFeedTamil'">
    <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="translationFeedTamil" style="display: block;">
      <app-all-wire-feed-listing pageId="translationFeedTamil"></app-all-wire-feed-listing>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'translationFeedTelegu'">
    <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="translationFeedTelegu" style="display: block;">
      <app-all-wire-feed-listing pageId="translationFeedTelegu"></app-all-wire-feed-listing>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'translationFeedMarathi'">
    <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="translationFeedMarathi" style="display: block;">
      <app-all-wire-feed-listing pageId="translationFeedMarathi"></app-all-wire-feed-listing>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'translationFeedKannada'">
    <div class="pageContainer tabcontent rssFeed photogalleryFeed" id="translationFeedKannada" style="display: block;">
      <app-all-wire-feed-listing pageId="translationFeedKannada"></app-all-wire-feed-listing>
    </div>
  </ng-container>
</ng-container>

